export default "__VITE_PUBLIC_ASSET__3441d903__"